import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IReportGroup, ReportGroup } from "@/models/report-group.entity";

export const ReportGroupDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IReportGroup, ""> {
  getIdentifier(entity: IReportGroup): string {
    return (entity as IReportGroup).id;
  }

  mapEntity(entity: IReportGroup): IReportGroup {
    return new ReportGroup(entity);
  }
})();
